import { Box } from "@mui/system";
import background from "@assets/svg/Group 547.svg";
import topImage from "@assets/svg/Group 525.svg";
import { Typography, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  step: number;
};

const Instructions: React.FC<Props> = ({ step }: Props) => {
  const { t } = useTranslation();

  return (
    <Box
      ml={12}
      sx={{
        position: "relative",
        display: {
          xs: "none",
          xl: "block",
        },
        height: "100%",
      }}
    >
      <img
        loading="lazy"
        style={{
        minHeight:"500px",
        maxHeight:"700px",

          position: "relative",
          top: "0",
          bottom: "0",
          right: "0",
          left: "0",
        }}
        src={background}
        alt="background group"
      />
      <Grid container sx={{ position: "absolute", top: "7%", left: "0", display: "flex" }} ml={9}>
        <Grid item>
          <Typography variant="h2" color="white">
            {t("Process explanation")}
          </Typography>
          <Grid item mt={6} mb={2} ml={2}>
            <img
              loading="lazy"
              style={{
                maxWidth: "70%",
                // transform: "translate(-60%, -50%)",
              }}
              src={topImage}
            />
          </Grid>
        </Grid>
        <Grid item xs={7}>
          <Typography variant="body1" color="white">
            {step == 1 &&
              t(`Your NetNut dashboard is just a few steps away! To create an
            account, choose a username, enter your email and create a password.
            Be sure to follow the guidelines for passwords listed below the
            form.`)}

            {step == 2 && t(`Please choose between “Company” and “Freelancer” and simply fill in all the required information in the form. `)}

            {step == 3 && t(`NetNut Proxy Network can be used for a wide range of purposes. To customize your experience on the platform, please choose all use cases that are relevant to you.`)}
            {step == 4 && t(`Almost done! The last step is to choose the right solution that will meet all your requirements. We provide our recommendation based on your selections, but you can choose whatever suits you best. You can also switch between solutions later in the account settings.`)}
          </Typography>
          <Typography paddingTop={2} fontWeight={600} variant="body1" color="white">
            {step == 1 && t(`Be aware that you will need the same username and password to configure NetNut proxies later`)}

            {step == 2 && t(`For Freelancers, we ask for an ID image. It can be any ID with your photo on it, including a local ID or a driving license. Your ID information will be stored securely and won’t be shared with anyone.`)}

            {step == 3 && t(`NetNut Proxy Network can be used for a wide range of purposes. To customize your experience on the platform, please choose all use cases that are relevant to you.`)}
            {step == 4 && t(`Almost done! The last step is to choose the right solution that will meet all your requirements. We provide our recommendation based on your selections, but you can choose whatever suits you best. You can also switch between solutions later in the account settings.`)}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Instructions;
